(ns common.schema.entities.workspace.workspace
  (:require [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field :workspace/name "Name" {:authorization su/access-user-user})
    (su/text-edn-field :workspace/settings "Settings" {:authorization su/access-user-ssg})
    (su/single-ref-field :workspace/target
                         "Target"
                         [:entity.type/kyc-process]
                         {:authorization    su/access-system-ssg
                          :system-semantics su/system-controlled-required-field-semantics
                          :system-required? true}))))
